import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { call } from '@spacefill/shared/src/utils/Backend';
import { safeLocalStorage } from '@spacefill/uikit/src/utils/storage';

export const RECENT_CONTEXT_SWITCHES_KEY = 'spacefill:external-console:recent-context-switches';

export function isOnOrderPage(pathname) {
    if (!pathname) {
        return false;
    }
    const orderPagePatterns = [
        /^\/orders\/[^/]+/,
        /^\/sales\/[^/]+/,
        /^\/entry-orders\/[^/]+/,
        /^\/exit-orders\/[^/]+/,
        /^\/logistic-management\/orders\/[^/]+/,
        /^\/logistic-management\/warehouses\/[^/]+\/orders\/[^/]+/,
        /^\/logistic-management\/warehouses\/[^/]+\/entry-orders\/[^/]+/,
        /^\/logistic-management\/warehouses\/[^/]+\/exit-orders\/[^/]+/,
        /^\/logistic-management\/entry-orders\/init/,
        /^\/logistic-management\/exit-orders\/init/,
        /^\/logistic-management\/warehouses\/[^/]+\/entry-orders\/init/,
        /^\/logistic-management\/warehouses\/[^/]+\/exit-orders\/init/,
        /^\/logistic-management\/warehouses\/[^/]+\/(entry-orders|exit-orders|orders)\/(new|new-entry|new-exit)/,
    ];

    return orderPagePatterns.some((pattern) => pattern.test(pathname));
}

export async function handleContextSwitch({
    switchValue = null,
    redirectFromOrderTo = '/',
    setLoading = null,
    currentPathname = null,
    skipRedirectFromOrder = false,
} = {}) {
    try {
        if (switchValue) {
            await call(
                '/users/',
                {},
                'GET',
                switchValue.type === 'CUSTOMER' ? { 'x-customer-id': switchValue.id } : { 'x-lsp-id': switchValue.id }
            );
        } else {
            await call('/users/', {}, 'GET');
        }
        if (setLoading) {
            setLoading(true);
        }
        // Conserver certains éléments "UI" (ex: derniers switches) malgré le clear global au changement de contexte.
        const preservedRecentSwitches = safeLocalStorage.getItem(RECENT_CONTEXT_SWITCHES_KEY);
        safeLocalStorage.clear();
        if (preservedRecentSwitches !== null) {
            safeLocalStorage.setItem(RECENT_CONTEXT_SWITCHES_KEY, preservedRecentSwitches);
        }
        const pathname = currentPathname ?? window.location.pathname;
        if (skipRedirectFromOrder) {
            window.location.reload();
        } else if (isOnOrderPage(pathname)) {
            window.location.href = redirectFromOrderTo;
        } else {
            window.location = '';
        }
    } catch {
        const preservedRecentSwitches = safeLocalStorage.getItem(RECENT_CONTEXT_SWITCHES_KEY);
        safeLocalStorage.clear();
        if (preservedRecentSwitches !== null) {
            safeLocalStorage.setItem(RECENT_CONTEXT_SWITCHES_KEY, preservedRecentSwitches);
        }
        window.location = '';
    }
}

export function isReloadPageAndClearStorageError(error) {
    if (!error) {
        return false;
    }
    if (error.details?.status === 'ReloadPageAndClearStorage') {
        return true;
    }
    return false;
}

export function useReloadPageAndClearStorageError(error) {
    const { pathname } = useLocation();
    useEffect(() => {
        if (error && isReloadPageAndClearStorageError(error)) {
            setTimeout(() => {
                handleContextSwitch({
                    currentPathname: pathname,
                    skipRedirectFromOrder: true,
                });
            }, 0);
        }
    }, [error, pathname]);
}
